// extracted by mini-css-extract-plugin
export default {"homeContainer":"Home_homeContainer__fM-95","quoteOfTheDayTitle":"Home_quoteOfTheDayTitle__+Nv+r","homeParagraph":"Home_homeParagraph__euWPL"};